module.exports = __webpack_public_path__ + "img/vaudoise.e08be9fd.png";